module.exports = __webpack_public_path__ + "img/card6.fdc123d9.png";